/**
 * Defines the methods used to generate invoices within the system.
 *
 * This enum provides predefined values representing different invoicing strategies,
 * allowing for consistent handling of invoicing processes across the codebase.
 * Each method is tied to a specific business context or requirement.
 */
export enum InvoiceMethod {
    SIMPLE = 1,
    PROJECT = 2
}